import '@web/shared-digital-library/icons/svg-originals/RSE-logo.svg';
import MdmIcon from '@/components/atoms/Global/MdmIcon.vue';
export default {
  name: 'ProductFlags',
  components: {
    MdmIcon
  },
  props: {
    flags: {
      type: Array,
      required: true
    },
    deliverySaleLabel: {
      type: Object,
      default: null
    },
    isOnSales: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isRse(flag) {
      return flag.code === 'IS_RSE';
    }
  }
};